export const RESET_LINK_MODE = {
  FORGOT: 'forgot',
  CHANGE: 'change',
};

export const RESET_LINK_CONFIG = {
  forgot: {
    titleKey: 'forgot_password',
    buttonKey: 'send_reset_link',
  },
  change: {
    titleKey: 'change_password',
    buttonKey: 'send_reset_link',
  },
};
